import { gql } from '@apollo/client';
export const UpdateLeaveRangeMutation = gql `
    mutation UpdateLeaveRange($siteSetId: InstitutionSetId!, $leaveRange: FiscalYear) {
        staffhours {
            settings {
                updateHolidayLeaveRangeV2(siteSetId: $siteSetId, leaveRange: $leaveRange)
            }
        }
    }
`;
